import React from 'react';

const Privacy = () => {
  return (
    <div style={{ minHeight: '100vh', padding: '120px 20px 80px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '60px', paddingBottom: '40px', borderBottom: '2px solid #e5e7eb' }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#f3f4f6',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#6b7280', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              LEGAL
            </span>
          </div>
          <h1 style={{ 
            fontSize: '48px', 
            fontWeight: '800', 
            color: '#1f2937',
            marginBottom: '16px',
            letterSpacing: '-0.5px'
          }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: '17px', color: '#6b7280' }}>
            Last updated: <strong>January 7, 2025</strong>
          </p>
        </div>

        {/* Content */}
        <div style={{ fontSize: '16px', lineHeight: '1.8', color: '#4b5563' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              1. Introduction
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Welcome to VentureOS ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. 
              This privacy policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
              and use our services.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              2. Information We Collect
            </h2>
            <p style={{ marginBottom: '12px' }}>
              We collect information that you provide directly to us, including:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Name and contact information (email address, phone number)</li>
              <li style={{ marginBottom: '8px' }}>Company name and professional role</li>
              <li style={{ marginBottom: '8px' }}>Account credentials and preferences</li>
              <li style={{ marginBottom: '8px' }}>Portfolio and investment data you choose to share</li>
              <li style={{ marginBottom: '8px' }}>Communications with our support team</li>
            </ul>
            <p>
              We also automatically collect certain information about your device and how you interact with our services, 
              including IP address, browser type, operating system, and usage patterns.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              3. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '12px' }}>
              We use the information we collect to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Provide, maintain, and improve our services</li>
              <li style={{ marginBottom: '8px' }}>Process your transactions and manage your account</li>
              <li style={{ marginBottom: '8px' }}>Send you technical notices, updates, and support messages</li>
              <li style={{ marginBottom: '8px' }}>Respond to your comments and questions</li>
              <li style={{ marginBottom: '8px' }}>Analyze usage patterns and optimize our platform</li>
              <li style={{ marginBottom: '8px' }}>Detect and prevent fraud and security issues</li>
              <li style={{ marginBottom: '8px' }}>Comply with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              4. Information Sharing and Disclosure
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We do not sell your personal information. We may share your information only in the following circumstances:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>With your consent or at your direction</li>
              <li style={{ marginBottom: '8px' }}>With service providers who perform services on our behalf</li>
              <li style={{ marginBottom: '8px' }}>To comply with legal obligations or respond to lawful requests</li>
              <li style={{ marginBottom: '8px' }}>To protect our rights, property, or safety, and that of our users</li>
              <li style={{ marginBottom: '8px' }}>In connection with a merger, acquisition, or sale of assets</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              5. Data Security
            </h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized 
              access, alteration, disclosure, or destruction. These measures include encryption, secure servers, and regular 
              security audits. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee 
              absolute security.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              6. Your Rights and Choices
            </h2>
            <p style={{ marginBottom: '12px' }}>
              You have the following rights regarding your personal data:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Access and receive a copy of your personal data</li>
              <li style={{ marginBottom: '8px' }}>Correct inaccurate or incomplete information</li>
              <li style={{ marginBottom: '8px' }}>Request deletion of your personal data</li>
              <li style={{ marginBottom: '8px' }}>Object to or restrict certain processing of your data</li>
              <li style={{ marginBottom: '8px' }}>Data portability</li>
              <li style={{ marginBottom: '8px' }}>Withdraw consent at any time</li>
            </ul>
            <p>
              To exercise these rights, please contact us at privacy@ventureos.com.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              7. Cookies and Tracking Technologies
            </h2>
            <p>
              We use cookies and similar tracking technologies to collect information about your browsing activities. 
              You can control cookies through your browser settings. Please note that disabling cookies may affect the 
              functionality of our services.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              8. International Data Transfers
            </h2>
            <p>
              Your information may be transferred to and processed in countries other than your country of residence. 
              We ensure appropriate safeguards are in place to protect your personal data in accordance with applicable 
              data protection laws.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              9. Children's Privacy
            </h2>
            <p>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal 
              information from children. If you become aware that a child has provided us with personal data, please 
              contact us.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              10. Changes to This Privacy Policy
            </h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any material changes by posting 
              the new policy on this page and updating the "Last updated" date. Your continued use of our services after 
              any changes constitutes your acceptance of the updated policy.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              11. Contact Us
            </h2>
            <p style={{ marginBottom: '12px' }}>
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f9fafb', 
              borderRadius: '8px',
              borderLeft: '4px solid #6366f1'
            }}>
              <p style={{ marginBottom: '8px' }}><strong>Email:</strong> privacy@ventureos.com</p>
              <p style={{ marginBottom: '8px' }}><strong>Address:</strong> VentureOS Inc.</p>
              <p>For data protection inquiries, please mark your communication as "Privacy Request"</p>
            </div>
          </section>
        </div>

        {/* Back to Home */}
        <div style={{ textAlign: 'center', marginTop: '80px', paddingTop: '60px', borderTop: '2px solid #e5e7eb' }}>
          <a 
            href="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '14px 28px',
              color: '#6b7280',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontWeight: '600',
              textDecoration: 'none',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
